<template>
	<div class="simple-proposal px-12 py-10">
		<p class="text-lg">
			{{proposal.texte}}
		</p>

		<button
		class="faa-button-blue mt-3"
		type="button"
		@click.prevent="nextClick">
			Continuer
		</button>
	</div>
</template>

<script>
	export default {
		name: 'SimpleProposal',
		props: {
			proposal: {
				type: Object,
				required: false,
				default: null
			}
		},
		methods: {
			nextClick() {
				this.$emit('next')
			}
		}
	}
</script>

<style lang="scss">
.simple-proposal {
	width: 100%;
	max-width: 100%;
	height: 100%;
	max-height: 100%;

	&-container {
		width: 100%;
		max-width: 100%;
		height: 100%;
		max-height: 100%;
	}

	video, img {
		width: auto;
		max-width: 100%;
		height: auto;
		max-height: 100%;
	}
}
</style>
